


















































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import httpApi from "@/API/Tenant/Weixin";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
//import echarts from "echarts";
const echarts = require("echarts"); // 图表

Vue.prototype.$echarts = echarts;
@Component({
  components: {
    echarts: echarts
  }
})
export default class OrderPayanalysis extends Vue {
  @Prop()
  private OrderPayAnalysisData: boolean | any; //从列表来的数据
  @Provide()
  private GetAppData: any = []; //取应用号信息
  private StartDate: any;
  private EndDate: any;
  private chartLineBoxData: any = [];
  private dailyDate: any;
  private loading = false;
  private loadingText = "数据加中,请稍后......";
  private NowData = new Date();
  data() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
    end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
    this.StartDate = start;
    this.EndDate = start;
    return {
      chartLineBoxData: [start, end],
      dailyDate: end,
      pickerOptions0: {
        disabledDate(time: any) {
          return time.getTime() > end;
        }
      }
    };
  }
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    this.GetOrderPayHour();
  }
  mounted() {}
  private back() {
    //this.$emit("refresh");
    this.$emit("backtable");
  }
  handleClick(tab: any, event: any) {
    let end = new Date();
    let start = new Date();
    switch (tab.paneName) {
      case "0":
        this.GetOrderPayHour();
        break;
      case "1":
        this.GetOrderPayWeek();
        break;
      case "2":
        this.GetOrderPayMonth();
        break;
      case "3":
        this.GetOrderPayYear();
        break;
      case "4":
        this.back();
        break;
    }
  }
  //统计分时数据
  async GetOrderPayHour() {
    if (!this.dailyDate) {
      this.$message.warning("请选择时间范围！");
      return;
    }
    //console.log(this.chartLineBoxData);
    let params: any = {
      Input: [
        {
          Name: "aid",
          Value: this.GetAppData.Aid
        },
        {
          Name: "StartDate",
          Value: this.dailyDate
        },
        {
          Name: "EndDate",
          Value: this.dailyDate
        },
        {
          Name: "TenantId",
          Value: this.GetAppData.TenantID
        },
        {
          Name: "type",
          Value: 1
        }
      ]
    };
    //console.log(params);
    this.loading = true;
    var res: any = await httpApi.GetPayOrderStatistics(params);
    this.loading = false;
    //console.log(res);
    if (res.ErrorCode == 0) {
      if (!res.output[0].value) {
        //this.$message.warning("支付数据(支付分时数据):暂无数据！");
        //return;
      }
      let category: any = [];
      let PaidCount: any = []; //已支付
      let unpaidCount: any = []; //未支付
      let RefundCount: any = []; //退款
      let ListData = res.output[0].value;
      for (var i = 0; i < 24; i++) {
        category.push(i + "点");
        let result = ListData.filter((d: { RefDate: any }) => d.RefDate == i);
        console.log(result);
        let unpaid = 0;
        let paid = 0;
        let Refund = 0;
        result.forEach((e: any) => {
          switch (e.State) {
            case 6:
              unpaid += e.Amount;
              break;
            case 9:
              paid += e.Amount;
              break;
            case 254:
              Refund += e.Amount;
              break;
            default:
              break;
          }
        });
        unpaidCount.push(unpaid);
        PaidCount.push(paid);
        RefundCount.push(Refund);
      }
      let pieEchart = document.getElementById("getorderpayhour");
      let pieEcharts = echarts.init(pieEchart);
      let option = {
        title: {
          text: "支付分时数据"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          data: ["已支付(元)", "未支付(元)", "已退款(元)"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: category // ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "已支付(元)",
            type: "line",
            smooth: true,
            stack: "金额(元)",
            data: PaidCount //[120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: "未支付(元)",
            type: "line",
            smooth: true,
            stack: "金额(元)",
            data: unpaidCount // [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: "已退款(元)",
            type: "line",
            smooth: true,
            stack: "金额(元)",
            data: RefundCount // [120, 132, 101, 134, 90, 230, 210]
          }
        ]
      };
      // console.log(option);
      pieEcharts.setOption(option);
    } else {
      //this.$message.error("获取支付分析分时数据:" + res.ErrorMessage);
    }
  }
  //统计日数据
  async GetOrderPayWeek() {
    if (!this.chartLineBoxData) {
      this.$message.warning("请选择时间范围！");
      return;
    }
    //console.log(this.chartLineBoxData);
    let params: any = {
      Input: [
        {
          Name: "aid",
          Value: this.GetAppData.Aid
        },
        {
          Name: "StartDate",
          Value: this.chartLineBoxData[0]
        },
        {
          Name: "EndDate",
          Value: this.chartLineBoxData[1]
        },
        {
          Name: "TenantId",
          Value: this.GetAppData.TenantID
        },
        {
          Name: "type",
          Value: 2
        }
      ]
    };
    //console.log(params);
    this.loading = true;
    var res: any = await httpApi.GetPayOrderStatistics(params);
    this.loading = false;
    //console.log(res);
    if (res.ErrorCode == 0) {
      let category: any = [];
      let PaidCount: any = []; //已支付
      let unpaidCount: any = []; //未支付
      let RefundCount: any = []; //退款
      let ListData = res.output[0].value;
      if (res.output[1].value) {
        res.output[1].value.forEach((element: any) => {
          category.push(element);
          let result = ListData.filter(
            (d: { RefDate: any }) => d.RefDate == element
          );
          //console.log(result);
          let unpaid = 0;
          let paid = 0;
          let Refund = 0;
          result.forEach((e: any) => {
            switch (e.State) {
              case 6:
                unpaid += e.Amount;
                break;
              case 9:
                paid += e.Amount;
                break;
              case 254:
                Refund += e.Amount;
                break;
              default:
                break;
            }
          });
          unpaidCount.push(unpaid);
          PaidCount.push(paid);
          RefundCount.push(Refund);
        });
      }
      let pieEchart = document.getElementById("getorderpayweek");
      let pieEcharts = echarts.init(pieEchart);
      let option = {
        title: {
          text: "支付日数据"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          data: ["已支付(元)", "未支付(元)", "已退款(元)"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: category // ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "已支付(元)",
            type: "line",
            smooth: true,
            stack: "金额(元)",
            data: PaidCount //[120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: "未支付(元)",
            type: "line",
            smooth: true,
            stack: "金额(元)",
            data: unpaidCount // [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: "已退款(元)",
            type: "line",
            smooth: true,
            stack: "金额(元)",
            data: RefundCount // [120, 132, 101, 134, 90, 230, 210]
          }
        ]
      };
      // console.log(option);

      pieEcharts.setOption(option);
    } else {
      this.$message.error("获取支付分析日数据:" + res.ErrorMessage);
    }
  }
  //统计月数据
  async GetOrderPayMonth() {
    if (!this.chartLineBoxData) {
      this.$message.warning("请选择时间范围！");
      return;
    }
    //console.log(this.chartLineBoxData);
    let params: any = {
      Input: [
        {
          Name: "aid",
          Value: this.GetAppData.Aid
        },
        {
          Name: "StartDate",
          Value: this.chartLineBoxData[0]
        },
        {
          Name: "EndDate",
          Value: this.chartLineBoxData[1]
        },
        {
          Name: "TenantId",
          Value: this.GetAppData.TenantID
        },
        {
          Name: "type",
          Value: 3
        }
      ]
    };
    //console.log(params);
    this.loading = true;
    var res: any = await httpApi.GetPayOrderStatistics(params);
    this.loading = false;
    //console.log(res);
    if (res.ErrorCode == 0) {
      let category: any = [];
      let PaidCount: any = []; //已支付
      let unpaidCount: any = []; //未支付
      let RefundCount: any = []; //退款
      let ListData = res.output[0].value;
      if (res.output[1].value) {
        res.output[1].value.forEach((element: any) => {
          category.push(element);
          let result = ListData.filter(
            (d: { RefDate: any }) => d.RefDate == element
          );
          //console.log(result);
          let unpaid = 0;
          let paid = 0;
          let Refund = 0;
          result.forEach((e: any) => {
            switch (e.State) {
              case 6:
                unpaid += e.Amount;
                break;
              case 9:
                paid += e.Amount;
                break;
              case 254:
                Refund += e.Amount;
                break;
              default:
                break;
            }
          });
          unpaidCount.push(unpaid);
          PaidCount.push(paid);
          RefundCount.push(Refund);
        });
      }
      let pieEchart = document.getElementById("getorderpaymonth");
      let pieEcharts = echarts.init(pieEchart);
      let option = {
        title: {
          text: "支付月数据"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          data: ["已支付(元)", "未支付(元)", "已退款(元)"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: category // ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "已支付(元)",
            type: "line",
            smooth: true,
            stack: "金额(元)",
            data: PaidCount //[120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: "未支付(元)",
            type: "line",
            smooth: true,
            stack: "金额(元)",
            data: unpaidCount // [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: "已退款(元)",
            type: "line",
            smooth: true,
            stack: "金额(元)",
            data: RefundCount // [120, 132, 101, 134, 90, 230, 210]
          }
        ]
      };
      // console.log(option);

      pieEcharts.setOption(option);
    } else {
      this.$message.error("获取支付分析月数据:" + res.ErrorMessage);
    }
  }
  //
  async GetOrderPayYear() {
    let params: any = {
      Input: [
        {
          Name: "aid",
          Value: this.GetAppData.Aid
        },
        {
          Name: "StartDate",
          Value: this.dailyDate
        },
        {
          Name: "EndDate",
          Value: this.dailyDate
        },
        {
          Name: "TenantId",
          Value: this.GetAppData.TenantID
        },
        {
          Name: "type",
          Value: 4
        }
      ]
    };
    //console.log(params);
    this.loading = true;
    var res: any = await httpApi.GetPayOrderStatistics(params);
    this.loading = false;
    console.log(res);
    if (res.ErrorCode == 0) {
      let ListData = res.output[0].value;
      if (ListData) {
        let unpaid = 0;
        let paid = 0;
        let Refund = 0;
        ListData.forEach((e: any) => {
          switch (e.State) {
            case 6:
              unpaid += e.Amount;
              break;
            case 9:
              paid += e.Amount;
              break;
            case 254:
              Refund += e.Amount;
              break;
            default:
              break;
          }
        });
        let option = {
          title: {
            text: "支付分析(年)",
            subtext: "",
            x: "center"
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            orient: "vertical",
            left: "left",
            data: ["已支付(元)", "未支付(元)"]
          },
          series: [
            {
              name: "支付类型",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: [
                { value: paid, name: "已支付(元)" },
                { value: unpaid, name: "未支付(元)" }
                //{ value: Refund, name: "已退款(元)" }
              ],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        };
        let pieEchart = document.getElementById("getorderpayyear");
        let pieEcharts = echarts.init(pieEchart);
        pieEcharts.setOption(option);
      }
    } else {
      this.$message.error("获取支付分析年数据:" + res.ErrorMessage);
    }
  }
}
